import { isNil } from 'ramda';

export const isNilOrWhitespace = (input: string | null | undefined): boolean =>
  isNil(input) || input.trim().length === 0;
